import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { history } from './../../../configuration/store';
import { isOnboardingPage } from '../../../utilities/navigation';
import { getInitials } from '../../../utilities/string';
import { logout } from './../../../reducers/identity';
import { setRoleSelectorVisibility } from '../../../reducers/dialogs';

import './user.css';

class UserMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = { element: null, roleSelectorVisible: false };

        this.onClick = this.onClick.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onClick(event) {
        this.setState({ ...this.state, element: event.currentTarget });
    }

    onClose() {
        this.setState({ ...this.state, element: null });
    }

    render() {
        const { profile, roles, isAuthenticated, logout, setRoleSelectorVisibility, id, hideUserMenuItems } = this.props;

        let { element } = this.state;

        if (!isAuthenticated) {
            return null;
        }

        return (
            <div className="user-menu no-select">
                <Button id={`${id}user-menu`} aria-owns={element ? 'user-menu' : null} aria-haspopup="true" onClick={this.onClick}>
                    {getInitials(profile)}
                </Button>
                <Menu id="user-menu" anchorEl={element} onClose={this.onClose} open={Boolean(element)}>
                    {roles.length > 1 && (
                        <MenuItem
                            onClick={() => {
                                setRoleSelectorVisibility(true);
                                this.onClose();
                            }}
                        >
                            <span className="user-menu-item">
                                <FormattedMessage id={'changeRole'} defaultMessage={'Change role'} />
                            </span>
                        </MenuItem>
                    )}
                    {!hideUserMenuItems && (
                        <Fragment>
                            <MenuItem
                                id={`${id}user-menu-profile`}
                                onClick={() => {
                                    history.push('/profile');
                                    this.onClose();
                                }}
                            >
                                <span className="user-menu-item">Profile</span>
                            </MenuItem>
                            <MenuItem
                                id="dashboard"
                                className="user-menu-item"
                                onClick={() => {
                                    history.push('/dashboard');
                                    this.onClose();
                                }}
                            >
                                Dashboard
                            </MenuItem>
                        </Fragment>
                    )}
                    <MenuItem className="user-menu-item" onClick={logout}>
                        <FormattedMessage {...messages.logout} />
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

UserMenu.defaultProps = {
    profile: undefined,
    isAuthenticated: false
};

UserMenu.propTypes = {
    profile: PropTypes.object,
    isAuthenticated: PropTypes.bool,
    hideUserMenuItems: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
    profile: state.identity.profile,
    isAuthenticated: state.identity.isAuthenticated,
    roles: state.identity.roles,
    hideUserMenuItems: isOnboardingPage(ownProps.location)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            logout,
            setRoleSelectorVisibility
        },
        dispatch
    );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserMenu));



// WEBPACK FOOTER //
// ./src/components/menus/user/index.jsx